<div class="heading">Deposit</div>
<div class="cont" [appLoading]="!isLoaded()">
  <div class="item" (click)="walletService.jump('deposit', 'web3Wallet')">
    <div class="tag">{{ walletTag() }}</div>
    <div class="title">{{ walletTitle() }}</div>
    <div class="desc">{{ walletDesc() }}</div>
    <div class="info">
      <img [src]="walletImg()" />
    </div>
  </div>
  <div class="item" (click)="walletService.jump('deposit', 'transfer')">
    <div class="title">Transfer your crypto</div>
    <div class="desc">BTC, ETH, USDT...</div>
    <div class="info">
      <img src="assets/images/first-deposit/first_deposit_2.png" />
    </div>
  </div>
  <div class="item" (click)="walletService.jump('deposit', 'buyCrypto')">
    <div class="title">Buy Crypto</div>
    <div class="desc">VISA, MasterCard, Apple Pay, Google Pay...</div>
    <div class="info" style="height: 20px">
      @if (localStorageService.theme == 'sun') {
        <img src="assets/images/first-deposit/first_deposit_3_light.png" />
      } @else {
        <img src="assets/images/first-deposit/first_deposit_3_dark.png" />
      }
    </div>
  </div>
</div>
